import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import "./i18n"
import axios from "axios"

axios.defaults.baseURL="https://izichange.com"; 
 
// const root = ReactDOM.createRoot(document.getElementById('root'));

const rootEl = document.getElementById('root');

if (rootEl && rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, <App />);
} else if (rootEl) {
  const root = createRoot(rootEl);
  root.render(<App />);
}
 